import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import color from 'color';
import chunk from 'lodash/chunk';
import { ColorSwatchButton } from './colorSwatchButton';
const CONTAINER_CSS = css `
  background-color: rgba(0, 0, 0, 0.1);
`;
const COLOR_GROUP_CSS = css `
  display: flex;
  flex-direction: row;
`;
export const ALLOWED_LUMINOSITY_THRESHOLD = 0.03;
/**
 * A color is "not allowed" if it is a rather dark color and the other color(s) that make up the avatar are also very dark.
 * This helps prevent users choosing difficult color combinations that make it really hard to see any details in the avatar's face.
 */
function isColorAllowed(currentColor, otherColorLuminosity) {
    if (otherColorLuminosity > ALLOWED_LUMINOSITY_THRESHOLD) {
        return true;
    }
    return color(currentColor).luminosity() > ALLOWED_LUMINOSITY_THRESHOLD;
}
export const ColorPickerGroupDisplay = ({ colorGroup, onColorClicked, onClose, otherColorLuminosity }) => {
    const colorsInChunks = chunk(colorGroup.colors, colorGroup.chunkSize || colorGroup.colors.length);
    return (_jsx("div", { css: CONTAINER_CSS, children: colorsInChunks.map((colorsInChunk, i) => {
            return (_jsx("div", { css: COLOR_GROUP_CSS, children: colorsInChunk.map((currentColor, j) => {
                    const isAllowed = isColorAllowed(currentColor, otherColorLuminosity);
                    const colorHex = color(currentColor).hex();
                    return (_jsx(ColorSwatchButton, { colorString: colorHex, onClick: () => {
                            onColorClicked(colorHex);
                            onClose();
                        }, isAllowed: isAllowed }, j));
                }) }, i));
        }) }));
};
